import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFormLibraryImport = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const importFormForClient = async ({ data }) => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.post(`${BASE_URL}v1/form-library/import`, data);
      setResponse(res.data);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return { response, error, isLoading, importFormForClient };
};

export default useFormLibraryImport; 